import { useMutation } from '@tanstack/react-query';
import { useRef } from 'react';
import { Endpoint } from '@/Config/api/endpoint';
import { SubscriptionApi } from '@/Domain/api/Subscription/Subscription.api';

export const useDraftSubscription = () => {
  const abortControllerRef = useRef<AbortController | null>(null);

  const mutation = useMutation({
    mutationKey: [Endpoint.subscription.draft],
    mutationFn: (priceId: string) => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      return SubscriptionApi.draft(priceId, abortControllerRef.current.signal);
    },
  });

  const handleDraft = (priceId: string) => mutation.mutate(priceId);

  const handleCancel = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };

  return { handleCancel, handleDraft, data: mutation.data, isPending: mutation.isPending };
};
